module.exports = __webpack_public_path__ + "media/images/img_photo-36ab49b6adffa7a8a8ffc00364b2fc60.png";